import React from 'react';

const PartsSourcing = () => (
  <div className='parts-sourcing mt-3'>
    <div className='row'>
      <div className='col-lg-12'>
        <div className=''>
          <p className='fw-bold'>
              Our network of authorized distributors includes:
          </p>
        </div>
      </div>
    </div>
    <div className='part-suppliers'>
      <div className='row'>
        <div className='col-xs-4 col-md-2 pe-0'>
          <img
            src={Spree.image_assets.digikey}
            className='img-fluid mx-auto align-self-start'
            alt='Digikey'/>
        </div>
        <div className='col-xs-4 col-md-2 px-0'>
          <img
            src={Spree.image_assets.mouser}
            className='img-fluid mx-auto align-self-start'
            alt='Mouser'/>
        </div>
        <div className='col-xs-4 col-md-2 ps-0'>
          <img
            src={Spree.image_assets.arrow}
            className='img-fluid mx-auto align-self-start'
            alt='Arrow'/>
        </div>
      </div>
    </div>
  </div>
);

export default PartsSourcing;
